<template>
    <Content class="col-span-full" :title="$route.name" v-loading="loading">
        <div class="col-span-full grid lg:grid-cols-4 gap-4 mb-8" v-if="company_vehicle">
            <Field type="col" align="start" :title="$t('STATUS')">
                <div class="flex items-center">
                    <span :style="`background-color:${state == 1 ? 'darkgreen' : 'darkred'}`"
                        class="rounded-xl py-1 px-4 text-white text-xs text-center shadow-md">{{ state == 1 ? $t('MOVING') :
                            $t('STOPPING') }}
                    </span>
                </div>
            </Field>

            <Field v-if="state == 1" type="col" align="start" :title="$t('MOVE_TIME_FROM')">
                {{ new Date(tripDetails.datetimes[0]).toLocaleTimeString("fa-IR") }} | {{ new
                    Date(tripDetails.datetimes[0]).toLocaleDateString("fa-IR") }}
            </Field>

            <Field v-if="state == 0" type="col" align="start" :title="$t('STOP_TIME_FROM')">
                {{ new Date(marker.datetimes).toLocaleTimeString("fa-IR") }} | {{ new
                    Date(marker.datetimes).toLocaleDateString("fa-IR") }}
            </Field>

            <Field type="col" align="start" :title="$t('VEHICLE_TITLE')">
                <LicensePlate :vehicle="company_vehicle.vehicle" :color="company_vehicle.color"
                    :license_plate="company_vehicle.license_plate" :chars="alphaList">
                </LicensePlate>
            </Field>
            <Field type="col" align="start" :title="$t('FULL_NAME') + ' ' + $t('DRIVER_TITLE')"
                v-if="company_vehicle.driver">{{
                    company_vehicle.driver.first_name + ' ' + company_vehicle.driver.last_name
                }}
            </Field>
            <Field v-if="company_vehicle.driver && company_vehicle.driver.mobile" type="col" align="start"
                :title="$t('MOBILE')">{{
                    "0" + company_vehicle.driver.mobile
                }}
            </Field>
        </div>

        <RoutingMap :tripDetail="tripDetails" :realtime="realtime" :marker="marker" :state="marker ? 0 : 1" />
    </Content>
</template>


<script>
import { tripReal } from "@/api/reports";
import RoutingMap from "@/components/reports/history/RoutingMap.vue";
import LicensePlate from "@/components/cars/LicensePlate";
import Field from "@/components/elements/field";
import { licenseChars } from "@/api/global";
export default {
    components: {
        RoutingMap,
        Field,
        LicensePlate
    },
    data() {
        return {
            loading: true,
            speeds: [
                {
                    data: [],
                },
            ],
            date: [],
            tripDetails: null,
            alphaList: [
                {
                    char: "",
                    code: "",
                },
            ],
            setInterval: '',
            realtime: false,
            marker: null,
            company_vehicle: null,
            state: 1
        }
    },
    methods: {
        loadRealtime(type = 0) {
            this.loading = true;
            tripReal.api(this.$route.params.id).then((res) => {
                this.loading = false;
                if (type != 0) {
                    this.realtime = true;
                }
                this.company_vehicle = res.company_vehicle
                if (res.state == 'trip') {
                    this.tripDetails = res;
                    this.marker = null;
                    this.state = 1;
                } else if (res.state == 'stop') {
                    this.marker = {
                        datetimes: res.datetime,
                        point: res.point
                    }
                    this.state = 0;
                    this.tripDetails = null;
                }

            });
        }
    },
    created() {
        this.loadRealtime();
        this.setInterval = setInterval(() => {
            this.loadRealtime(1);
        }, 60000);

        licenseChars.api().then((res) => {
            this.alphaList = res;
        });
    },
    beforeDestroy() {
        clearInterval(this.setInterval)
    }
}
</script>